import React from 'react'
import News_1 from '../../../assets/images/subscribe/01.png'

const News = () => {
    return (
        <>
            <section id="subscribe" className="subscribe-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 offset-md-2">
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="subscribe-img">
                                        <img
                                            src={News_1}
                                            className="img-fluid"
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="subscribe-dtls">
                                        <h4 className="subscribe-heading">
                                            Get 40% Discount Buying First Product
                                        </h4>
                                        <div className="form-group-subscribe-form">
                                            <form>
                                                <div className="form-group">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        id="subscribe-email"
                                                        placeholder="exampleinfo@gmail.com"
                                                    />
                                                    <button type="button" className="btn btn-primary-four">
                                                        Subscribe
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default News
